import useLanguageNavigate from '@hooks/useLanguageNavigate';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useUsersStore } from 'services/users';
import { useMonitoringOffersStore } from 'services/monitoring-offers';

export default function MonitoringPhaseMainCard({ data, reports = [] }: any) {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();
	const { user } = useUsersStore();
	const { selectedOffer } = useMonitoringOffersStore();
	
	// Get the offer data from store or localStorage
	const offer =
		Object.keys(selectedOffer).length === 0
			? JSON.parse(localStorage.getItem('selectedOffer') || '{}')
			: selectedOffer;
	
	// Find report for this phase if it exists
	const report = offer?.report?.find((r: any) => r.phases_id === data.phases_id);

	const isFarmerPath = user?.role?.toLowerCase() === 'farmer';

	const handleNavigate = () => {
		navigateWithLanguage(
			`/${isFarmerPath ? 'farmer' : 'specialist'}/monitoring/project/${data.phases_id}/topics`
		);
	};
	
	const handleReportClick = (e: React.MouseEvent, reportLink: string) => {
		e.stopPropagation(); // Prevent card click event
		window.open(reportLink, '_blank');
	};

	const daysLeft = moment(data.phases_closed).diff(moment(data.phases_open), 'days');

	return (
		<div
			className="cursor-pointer max-xsm:flex-col lg:max-w-[420px] flex flex-row justify-between items-start px-5 py-3 border-[2px] border-primary rounded-xl bg-white shadow-lg"
			onClick={handleNavigate}
		>
			<div className="flex flex-col gap-1">
				<div className="flex flex-row gap-1 items-center">
					<span className="font-bold text-dark text-base">{t('phase')}:</span>
					<span className="font-normal text-dark text-base">{data.phases_name}</span>
				</div>
				{/* Commented out days left display
				<span className="text-base text-light-grey text-sm font-normal">
					{t('daysLeft', { days: daysLeft })}
				</span>
				*/}
			</div>

			<div className="flex flex-row gap-4 items-center justify-center">
				{report ? (
					<>
						<div 
							className="text-primary gap-2 flex items-center justify-center cursor-pointer"
							onClick={(e) => handleReportClick(e, report.report_link)}
						>
							<span className="font-semibold text-base text-primary underline">F-100</span>
						</div>
						<KeyboardArrowRightOutlinedIcon className="text-primary" />
					</>
				) : (
					<>
						<div className="text-custom-yellow gap-2 flex items-center justify-center border border-custom-yellow rounded-lg px-2">
							<CheckCircleOutlineOutlinedIcon />
							<span className="font-semibold text-base text-custom-yellow">{t('inProgress')}</span>
						</div>
						<KeyboardArrowRightOutlinedIcon className="text-primary" />
					</>
				)}
			</div>
		</div>
	);
}
